import React, { HTMLAttributes } from 'react';
interface IConfirmModal2Props extends HTMLAttributes<HTMLDialogElement> {
  onClose: () => void;
}
const ConfirmModal2: React.FC<IConfirmModal2Props> = ({ children, onClose }) => {
  const ref = React.useRef<HTMLDialogElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;
    const handleClose = () => {
      onClose();
    };

    ref.current.addEventListener('close', handleClose);

    (ref.current as any).showModal();

    return () => {
      ref.current && ref.current.removeEventListener('close', handleClose);
    };
  }, []);

  return (
    <dialog className="border-0 rounded p-0 shadow" ref={ref}>
      {children}
    </dialog>
  );
};

export default ConfirmModal2;
